import PropTypes from 'prop-types';
import React from 'react';
import MenuButton from './menu_button.ui';
import connect from './connect';
import { routeToTerm } from '../actions/route';
import { setCurrentTerm } from 'actions/terms';
import { selectSortedTerms } from '../selectors/terms';
import { createStructuredSelector } from 'reselect';

class TermMenu extends React.Component {
    static displayName = 'TermMenu';

    static propTypes = {
        routeToTerm: PropTypes.func.isRequired,
        setCurrentTerm: PropTypes.func.isRequired,
        terms: PropTypes.array,
        value: PropTypes.number.isRequired,
    };

    onSelection = (termId, event) => {
        // We need to let the menu close before removing it from the DOM
        setTimeout(() => {
            this.props.routeToTerm({ termId });
            this.props.setCurrentTerm(termId);
        });
    };

    render() {
        const { terms, value } = this.props;

        if (terms.length === 0) {
            return null;
        }

        const currentTerm = terms.reduce((memo, next) => {
            if (next.id === value) {
                return next;
            }
            return memo;
        });

        const renderItem = term => <span key={term.id}>{term.name}</span>;

        return (
            <MenuButton
                onSelection={this.onSelection}
                renderItem={renderItem}
                items={terms}
            >
                <span>
                    <span className="aural">Term: </span>
                    {currentTerm.name}
                </span>
            </MenuButton>
        );
    }
}

export default connect(
    createStructuredSelector({
        terms: selectSortedTerms,
    }),
    { routeToTerm, setCurrentTerm }
)(TermMenu);



// WEBPACK FOOTER //
// ./src/components/term_menu.jsx